import React from "react";
import { Box, Stack, Typography, SvgIcon, Grid } from "@mui/material";
import { ReactComponent as SearchIcon } from "../../../../assets/search2.svg";
import { ReactComponent as BoxIcon } from "../../../../assets/boxes.svg";
import { ReactComponent as HistoryIcon } from "../../../../assets/history.svg";
import { ReactComponent as PhoneIcon } from "../../../../assets/phone.svg";
import { ReactComponent as QRIcon } from "../../../../assets/scan.svg";
import { ReactComponent as SellerIcon } from "../../../../assets/star_person.svg";
import { ReactComponent as ChromeIcon } from "../../../../assets/chrome.svg";
import { ReactComponent as MapIcon } from "../../../../assets/map.svg";

interface Tool {
  icon: React.ReactNode;
  title: string;
  description: string;
}

const Fields = (): JSX.Element => {
  const tools = [
    [
      {
        icon: <SvgIcon component={SearchIcon} sx={{ width: 24, height: 24 }} />,
        title: "Product Analyzer",
        description:
          "Deep Dive analysis of product performance and market insights.",
      },
      {
        icon: (
          <SvgIcon component={HistoryIcon} sx={{ width: 24, height: 24 }} />
        ),
        title: "History",
        description: "Tracks and analyzes previously searched product data.",
      },
      {
        icon: <SvgIcon component={QRIcon} sx={{ width: 24, height: 24 }} />,
        title: "Bulk Analyzer",
        description:
          "Quickly analyze products in bulk by uploading a spreadsheet",
      },
      {
        icon: <SvgIcon component={SellerIcon} sx={{ width: 24, height: 24 }} />,
        title: "Sellers",
        description: "Browse and analyze millions of Amazon sellers",
      },
      {
        icon: <SvgIcon component={MapIcon} sx={{ width: 24, height: 24 }} />,
        title: "Seller Map",
        description: "Geolocate Amazon sellers and regional selling patterns.",
      },
    ],
    [
      {
        icon: <SvgIcon component={BoxIcon} sx={{ width: 24, height: 24 }} />,
        title: "Supplier",
        description:
          "Access our curated database of verified and reliable suppliers.",
      },

      {
        icon: <SvgIcon component={PhoneIcon} sx={{ width: 24, height: 24 }} />,
        title: "Mobile App",
        description:
          "Get our mobile app to easily scan and analyze products on the go",
      },

      {
        icon: <SvgIcon component={ChromeIcon} sx={{ width: 24, height: 24 }} />,
        title: "Chrome Extension",
        description:
          "Get our mobile app to easily scan and analyze products on the go",
      },
    ],
  ];

  return (
    <Stack
      sx={{
        border: "1px solid rgba(227, 227, 227, 0.7)",
        boxShadow: "none",
        padding: "10px",
        borderRadius: "4px",
        height: { md: "500px", sm: "100%" },
        flexGrow: 1,
      }}
    >
      <Typography variant="h4" fontWeight={700} mb={2}>
        Browse Tools
      </Typography>

      <Box
        display={"grid"}
        gridTemplateColumns={{ sm: "1fr 1fr", xs: "1fr" }}
        gap={{ md: "32px", sm: "0px" }}
      >
        {tools.map((item, index1) => (
          <Box display={"flex"} flexDirection={"column"} key={index1}>
            {item.map((tool, index2) => (
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  marginBottom: "20px",
                }}
                key={tool.title}
              >
                <Box
                  sx={{ display: "flex", alignItems: "flex-start", gap: 1.5 }}
                >
                  {tool.icon}
                  <Typography
                    variant="h4"
                    sx={{ fontWeight: 500, color: "#333333" }}
                  >
                    {tool.title}
                  </Typography>
                </Box>
                <Typography
                  variant="body2"
                  sx={{
                    ml: "36px",
                    fontWeight: 400,
                    fontSize: "13px",
                    color: "rgba(51, 51, 51, 0.6)",
                    maxWidth: "220px",
                  }}
                >
                  {tool.description}
                </Typography>
              </Box>
            ))}
          </Box>
        ))}
      </Box>
    </Stack>
  );
};

export default Fields;
